import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/Services/notification.service';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit {

  constructor(private notificationService: NotificationService) { }

  notificationsOpened = false;
  notifications : any[] = [];
  unseenNotifications : any[] = [];

  ngOnInit(): void {
    this.notificationService.getNotifications().subscribe({
      next: (res: any) => {
        if (res.status && res.message === 'success') {
          this.notifications = res.body;
          this.unseenNotifications = this.notifications.filter((notif: any) => !notif.opened);
        }
      },
      error: (err) => {
        console.error("Error fetching notifications:", err);
      }
    });
  }

  toggleNotifications() {
    this.notificationsOpened = !this.notificationsOpened;
    if (this.notificationsOpened) {
      this.unseenNotifications.forEach(notif => {
        this.notificationService.updateNotification(notif.id).subscribe();
      });
      this.unseenNotifications = [];
    }
  }

  notificationsClosed() {
    this.notificationsOpened = false;
  }
}
